// https://github.com/Akryum/vue-observe-visibility/blob/master/src/directives/observe-visibility.js
import isEqual from 'lodash/isEqual'

class VisibilityState {
  constructor(el, options, vNode) {
    this.el = el
    this.observer = null
    this.callback = null
    this.oldResult = null

    const opts = {
      threshold: options.threshold || 0,
      callback: options.callback || function () { },
      once: options.once || false,
    }

    this.createObserver(opts, vNode)
  }

  createObserver(opts, vNode) {
    const { once, threshold, ...options } = opts
    if (this.observer != null) {
      this.destroyObserver()
    }

    this.callback = (result, entry) => {
      options.callback(result, entry)
      if (result && once) this.destroyObserver()
    }

    this.observer = new IntersectionObserver(entries => {
      const _entries = Array.from(entries || [])
      const entry = (_entries || []).find(e => e.isIntersecting) || (_entries || [])[0]

      if (this.callback) {
        if (entry.isIntersecting === this.oldResult) return
        this.oldResult = entry.isIntersecting
        this.callback(entry.isIntersecting, entry)
      }
    }, {
      threshold,
    })

    vNode.context.$nextTick(() => {
      if (this.observer) this.observer.observe(this.el)
    })
  }

  destroyObserver() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }
}

function bind(el, { value }, vNode) {
  if (!value) {
    console.error(`value needed to perform actions received ${value}`);
    return
  }

  const state = new VisibilityState(el, value, vNode);
  el._vue_visibilityState = state
}

function update(el, { value, oldValue }, vNode) {
  if (isEqual(value, oldValue)) return
  if (!value) return unbind(el)

  if (el._vue_visibilityState) {
    el._vue_visibilityState.createObserver(value, vNode)
  } else {
    bind(el, { value }, vNode)
  }
}

function unbind(el) {
  if (el._vue_visibilityState) {
    el._vue_visibilityState.destroyObserver()
    delete el._vue_visibilityState
  }
}

export default {
  bind,
  update,
  unbind,
}
